import VueMoment from 'vue-moment';

export default ({Vue}) => {
  Vue.use(VueMoment);
}

